import { render, staticRenderFns } from "./GalleryViewer.vue?vue&type=template&id=7e856824&scoped=true&"
import script from "./GalleryViewer.vue?vue&type=script&lang=js&"
export * from "./GalleryViewer.vue?vue&type=script&lang=js&"
import style0 from "./GalleryViewer.vue?vue&type=style&index=0&id=7e856824&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e856824",
  null
  
)

export default component.exports